import { IQuizConfig, IValidatedQuestion } from '@sdk/contracts';
import { create } from 'zustand';

const DEFAULT_TIMER = 30;

interface IStore {
  isConfigOpen: boolean;
  setConfigOpen: (isConfigOpen: boolean) => void;
  config: IQuizConfig;
  setConfig: (config?: IQuizConfig) => void;
  questions?: IValidatedQuestion[];
  setQuestions: (questions?: IValidatedQuestion[]) => void;
  isQuestionBankOpen: boolean;
  isInstructionsOpen: boolean;
  setIsQuestionBankOpen: (isQuestionBankOpen: boolean) => void;
  setIsInstructionsOpen: (isInstructionsOpen: boolean) => void;
  resetConfig: () => void;
  selectedQuestion?: number;
  setSelectedQuestion: (question?: number) => void;
  isDescriptionFormOpen: boolean;
  setIsDescriptionFormOpen: (isDescriptionFormOpen: boolean) => void;
  quizDescription?: string;
  setQuizDescription: (quizDescription?: string) => void;
}

export const useQuizForm = create<IStore>(set => ({
  isConfigOpen: false,
  setConfigOpen: (isConfigOpen: boolean) => set({ isConfigOpen }),
  config: {
    timer: DEFAULT_TIMER
  } as IQuizConfig,
  setConfig: (config?: IQuizConfig) => set({ config }),
  setQuestions: (questions?: IValidatedQuestion[]) => set({ questions }),
  isQuestionBankOpen: false,
  isInstructionsOpen: false,
  setIsQuestionBankOpen: (isQuestionBankOpen: boolean) => set({ isQuestionBankOpen }),
  setIsInstructionsOpen: (isInstructionsOpen: boolean) => set({ isInstructionsOpen }),
  resetConfig: () => set({ config: { timer: DEFAULT_TIMER } as IQuizConfig }),
  setSelectedQuestion: (question?: number) => set({ selectedQuestion: question }),
  isDescriptionFormOpen: false,
  setIsDescriptionFormOpen: (isDescriptionFormOpen: boolean) => set({ isDescriptionFormOpen }),
  setQuizDescription: (quizDescription?: string) => set({ quizDescription })
}));
